import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, vueVersion } from "./TUIKit/adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import router from "./router/index";
import { Message } from "element-ui";
import { SDKAppID } from "./main";
import { TUILogin } from "@tencentcloud/tui-core";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const locale = ref<string>("zh");
TUIStore.watch(StoreName.USER, {
  kickedOut: (value: string) => {
    if (value && router.currentRoute.name !== "Login") {
      Message.error({
        message: "您已被挤下线，请重新登录！",
      });
      localStorage.removeItem("TUIKit-userInfo");
      window.location.assign("/login");
      localStorage.clear();
    }
  },
});
onMounted(() => {
  let tencent_accid = localStorage.getItem("tencent_accid");
  let tencent_token = localStorage.getItem("tencent_token");
  const loginInfo: any = {
    SDKAppID,
    userID: tencent_accid,
    userSig: tencent_token,
    useUploadPlugin: true,
    framework: `vue${vueVersion}`,
  };
  let path = router.history._startLocation;
  path != "/home" &&
    router.currentRoute &&
    tencent_accid &&
    tencent_token &&
    TUILogin.login(loginInfo).catch((error) => {
      Message.error({
        message: error,
      });
    });
});
function changeLanguage(language: string) {
  locale.value = language;
}

return { __sfc: true,locale, changeLanguage }
}

})